const translations = {
  'Hello!': {
    en: 'Hello!',
    es: '¡Hola!',
    pt: 'Olá!',
  },
  'and': {
    en: 'and',
    es: 'y',
    pt: 'o',
  },
  'Continue': {
    en: 'Continue',
    es: 'Continuar',
    pt: 'Continuar',
  },
  'Back': {
    en: 'Back',
    es: 'Volver',
    pt: 'Voltar',
  },
  'here': {
    en: 'here',
    es: 'aquí',
    pt: 'aqui',
  },
  'See more': {
    en: 'See more',
    es: 'Ver más',
    pt: 'Ver mais',
  },
  'More': {
    en: 'More',
    es: 'Más',
    pt: 'Mais',
  },
  'All': {
    en: 'All',
    es: 'Todos',
    pt: 'Todos',
  },
  'Today': {
    en: 'Today',
    es: 'Hoy',
    pt: 'Hoje',
  },
  'Tomorrow': {
    en: 'Tomorrow',
    es: 'Mañana',
    pt: 'Amanhã',
  },
  'Live': {
    en: 'Live',
    es: 'En vivo',
    pt: 'Ao vivo',
  },
  'Final': {
    en: 'Final',
    es: 'Finalizado',
    pt: 'Encerrado',
  },
  'monday': {
    en: 'Monday',
    es: 'Lunes',
    pt: 'Segunda',
  },
  'tuesday': {
    en: 'Tuesday',
    es: 'Martes',
    pt: 'Terça',
  },
  'wednesday': {
    en: 'Wednesday',
    es: 'Miércoles',
    pt: 'Quarta',
  },
  'thursday': {
    en: 'Thursday',
    es: 'Jueves',
    pt: 'Quinta',
  },
  'friday': {
    en: 'Friday',
    es: 'Viernes',
    pt: 'Sexta',
  },
  'saturday': {
    en: 'Saturday',
    es: 'Sábado',
    pt: 'Sábado',
  },
  'sunday': {
    en: 'Sunday',
    es: 'Domingo',
    pt: 'Domingo',
  },
  'Not now': {
    en: 'Not now',
    es: 'Ahora no',
    pt: 'Agora não',
  },
  'Close': {
    en: 'Close',
    es: 'Cerrar',
    pt: 'Fechar',
  },
  'Soon': {
    en: 'Soon',
    es: 'Próximamente',
    pt: 'Breve'
  },
  'WatchNow': {
    en: 'Watch Now',
    es: 'Mirar Ahora',
    pt: 'Assista Agora'
  },
  'Day': {
    en: 'Day',
    es: 'Día',
    pt: 'Dia',
  },
  'to': {
    en: 'to',
    es: 'a',
    pt: 'até',
  },
  'Apply': {
    en: 'Apply',
    es: 'Aplicar',
    pt: 'Aplicar'
  },
  'Go to home': {
    en: 'Go to home',
    es: 'Ir al inicio',
    pt: 'Vá para o começo'
  },
  'I agree to the': {
    en: 'I agree to the',
    es: 'Estoy de acuerdo con los',
    pt: 'Estou de acordo com o'
  },
  'This site is protected by reCAPTCHA and the Google': {
    en: 'This site is protected by reCAPTCHA and the Google',
    es: 'Este sitio está protegido por reCAPTCHA y Google',
    pt: 'Este sítio está protegido pelo reCAPTCHA e o Google'
  },
  'Privacy Policy': {
    en: 'Privacy Policy',
    es: 'Política de Privacidad',
    pt: 'Política de Privacidade',
  },
  'Terms of Service': {
    en: 'Terms of Service',
    es: 'Términos de Servicio',
    pt: 'Termos de Serviço',
  },
  'Terms and Conditions': {
    en: 'Terms and Conditions',
    es: 'Términos y Condiciones',
    pt: 'Termos e Condições',
  },
  'Go back to home': {
    en: 'Go back to home',
    es: 'Volver al inicio',
    pt: 'Voltar para o começo'
  },
  'You\'re being redirected': {
    en: 'You\'re being redirected',
    es: 'Estás siendo redirigido',
    pt: 'Você está sendo redirecionado'
  },
  'Page not found': {
    en: 'Page not found',
    es: 'Página no encontrada',
    pt: 'Página não encontrada'
  },
  'Sorry, the page you are looking for does not exist': {
    en: 'Sorry, the page you are looking for does not exist',
    es: 'Lo sentimos, la página que estás buscando no existe',
    pt: 'Desculpe, a página que você está procurando não existe'
  },
  'An error occurred': {
    en: 'An error occurred',
    es: 'Ocurrió un error',
    pt: 'Ocorreu um erro'
  },
  'Paused': {
    en: 'Paused',
    es: 'Pausado',
    pt: 'Pausado'
  },
  'Active': {
    en: 'Active',
    es: 'Activo',
    pt: 'Ativo'
  },
  'Canceled': {
    en: 'Canceled',
    es: 'Cancelado',
    pt: 'Cancelado'
  },
  'Past Due': {
    en: 'Past Due',
    es: 'Vencido',
    pt: 'Vencido'
  },
  'Trialing': {
    en: 'Trialing',
    es: 'En prueba',
    pt: 'Em teste'
  },
  'Pending': {
    en: 'Pending',
    es: 'Pendiente',
    pt: 'Pendente'
  },
  'Profile': {
    en: 'Profile',
    es: 'Perfil',
    pt: 'Perfil'
  },
  'Logout': {
    en: 'Logout',
    es: 'Cerrar sesión',
    pt: 'Sair'
  },
  'Try again': {
    en: 'Try again',
    es: 'Intentar de nuevo',
    pt: 'Tente novamente'
  },
  'Reference code: {code}': {
    en: 'Reference code: {code}',
    es: 'Código de referencia: {code}',
    pt: 'Código de referência: {code}'
  },
  'Document': {
    en: 'Document',
    es: 'Documento',
    pt: 'Documento'
  },
  'Document type': {
    en: 'Type',
    es: 'Tipo',
    pt: 'Tipo'
  },
  'Document number': {
    en: 'Document number',
    es: 'Número de documento',
    pt: 'Número do documento'
  },
  'Phone code': {
    en: 'Phone code',
    es: 'Código telefónico',
    pt: 'Código telefônico'
  },
  'Phone number': {
    en: 'Phone number',
    es: 'Número de teléfono',
    pt: 'Número de telefone'
  },
  'Save': {
    en: 'Save',
    es: 'Guardar',
    pt: 'Salvar'
  },
  'Edit': {
    en: 'Edit',
    es: 'Editar',
    pt: 'Editar'
  },
  'Content not available': {
    en: 'Content not available',
    es: 'Contenido no disponible',
    pt: 'Conteúdo não disponível'
  },
  'Back to Home': {
    en: 'Back to Home',
    es: 'Volver al Inicio',
    pt: 'Voltar para o Início'
  },
  'This content is not accessible from your location': {
    en: 'This content is not accessible from your location',
    es: 'Este contenido no está disponible desde su ubicación',
    pt: 'Este conteúdo não está disponível desde sua localização'
  },
  'Watch now': {
    en: 'Watch now',
    es: 'Mirar ahora',
    pt: 'Assistir agora'
  },
  'Watch': {
    en: 'Watch',
    es: 'Ver',
    pt: 'Assistir'
  },
  'Play': {
    en: 'Play',
    es: 'Reproducir',
    pt: 'Reproduzir'
  },
  'A small temporary hold may apply to verify your card details. It will be refunded automatically.': {
    en: 'A small temporary hold may apply to verify your card details. It will be refunded automatically.',
    es: 'Podría aplicarse un pequeño cargo temporal para verificar los datos de tu tarjeta. Se reembolsará automáticamente.',
    pt: 'Uma pequena cobrança temporária pode ser aplicada para verificar os dados do seu cartão. Ela será reembolsada automaticamente.'
  },
  'Favorite Team': {
    en: 'Favorite Team',
    es: 'Equipo Favorito',
    pt: 'Time Favorito'
  },
  'vs': {
    en: 'vs',
    es: 'vs',
    pt: 'x'
  },
  'Watch live broadcasts, schedule upcoming matches, and relive the best moments.': {
    en: 'Watch live broadcasts, schedule upcoming matches, and relive the best moments.',
    es: 'Mira transmisiones en vivo, programa próximos partidos y revive los mejores momentos.',
    pt: 'Assista a transmissões ao vivo, programe partidas futuras e reviva os melhores momentos.'
  },
  'Next': {
    en: 'Next',
    es: 'Siguiente',
    pt: 'Próximo'
  },
  'Got it': {
    en: 'Got it',
    es: 'Entendido',
    pt: 'Entendi'
  },
  'New': {
    en: 'New',
    es: 'Nuevo',
    pt: 'Novo'
  },
  'Search': {
    en: 'Search',
    es: 'Buscar',
    pt: 'Buscar'
  },
  'Remove': {
    en: 'Remove',
    es: 'Quitar',
    pt: 'Remover'
  },
  'Oops!': {
    en: 'Oops!',
    es: '¡Ups!',
    pt: 'Ops!'
  },
  'Go back': {
    en: 'Go back',
    es: 'Volver',
    pt: 'Voltar'
  },
  'This field is required': {
    en: 'This field is required',
    es: 'Este campo es obligatorio',
    pt: 'Este campo é obrigatório'
  },
  'This field cannot contain invalid characters': {
    en: 'This field cannot contain invalid characters',
    es: 'Este campo no puede contener caracteres inválidos',
    pt: 'Este campo não pode conter caracteres inválidos'
  },
  'This field must have max 2 characters': {
    en: 'This field must have max 2 characters',
    es: 'Este campo debe tener máximo 2 caracteres',
    pt: 'Este campo deve ter no máximo 2 caracteres'
  },
  'View match': {
    en: 'View match',
    es: 'Ver partido',
    pt: 'Ver partida'
  },
  'View match details': {
    en: 'View match details',
    es: 'Ver detalles del partido',
    pt: 'Ver detalhes da partida'
  },
  'Local team score': {
    en: 'Local team score',
    es: 'Marcador del equipo local',
    pt: 'Placar do time da casa'
  },
  'Away team score': {
    en: 'Away team score',
    es: 'Marcador del equipo visitante',
    pt: 'Placar do time visitante'
  },
  'Something went wrong loading the app': {
    en: 'Something went wrong loading the app',
    es: 'Algo salió mal al cargar la aplicación',
    pt: 'Algo deu errado ao carregar o aplicativo'
  },
  'Reload': {
    en: 'Reload',
    es: 'Recargar',
    pt: 'Recarregar'
  },
  'Try again later': {
    en: 'Try again later',
    es: 'Inténtalo de nuevo más tarde',
    pt: 'Tente novamente mais tarde'
  }
}

export default translations